
<template lang="pug">
    div.tw-w-full
      div(v-if="title" class="2xl:tw-text-xl xl:tw-text-base tw-font-semibold tw-text-primary_brand tw-mb-2") {{ title }}
      div.tw-w-full.adjustHeight(v-if="data.categories.length") 
        highcharts.tw-w-full(:options="chartData")
      div(v-else class="tw-p-4 2xl:tw-text-sm xl:tw-text-xs tw-text-red-800 tw-rounded-lg tw-bg-red-50") No data available in chart!
    </template>
    
    <script>
    import moment from "moment";
    
    export default {
      name: "negativeColumnChart",
      props: ["data", "topMargin", "title", "height", "isLegend"],
    
      data() {
        return {
          chartData: {},
        };
      },
    
      watch: {
        data: {
          deep: true,
          handler() {
            this.initiate();
          },
        },
      },
    
      mounted() {
        this.initiate();
      },
    
      methods: {
        formatXAxis(dateArray) {
          const resultArray = [];
          for (const dateString of dateArray) {
            const dateObj1 = moment(dateString, "DD MMM YYYY", true);
            const dateObj2 = moment(dateString, "YYYY-MM-DD", true);
            if (dateObj1.isValid()) {
              resultArray.push(dateObj1.format("DD MMM"));
            } else if (dateObj2.isValid()) {
              resultArray.push(dateObj2.format("DD MMM"));
            } else {
              resultArray.push(dateString);
            }
          }
          return resultArray;
        },
    
        chartHeight() {
          if (this.height) {
            return this.height + "px";
          } else {
            return "60%";
          }
        },
    
        ChartMarginTop() {
          return this.topMargin || "50";
        },
    
        yTitleSize() {
          return window.screen.width < 600 ? 9 : false;
        },
    
        legendFontSize() {
          return window.screen.width < 600 ? "2vw" : "0.8vw";
        },
    
        legendPosition() {
          return window.screen.width < 600 ? "center" : "right";
        },
    
        symbolHeight() {
          return window.screen.width < 600 ? 7 : 14;
        },
    
        symbolRadius() {
          return window.screen.width < 600 ? 2 : 4;
        },
    
        abbreviateNumber(value) {
          if (window.screen.width < 600) {
            return Intl.NumberFormat("en-US", {
              notation: "compact",
              maximumFractionDigits: 2,
            }).format(value);
          }
          return value.toLocaleString("en-US");
        },
    
        lineMarker() {
          if (window.screen.width < 600) {
            return {
              enabled: true,
              radius: 1.5,
              states: {
                hover: {
                  radiusPlus: 1,
                  lineWidthPlus: 1,
                },
              },
            };
          } else {
            return {
              states: {
                hover: {
                  radiusPlus: 3,
                  lineWidthPlus: 3,
                },
              },
            };
          }
        },
    
        labelFontSize() {
          return window.screen.width < 600 ? 9 : 11;
        },
    
        plotLegend() {
          if (this.isLegend) {
            return true;
          } else if (!this.isLegend) {
            return false;
          }
        },
    
        initiate() {
          const self = this;
          if (!self.data.seriesData.length) {
            return;
          }
    
        //   const seriesData = [
        //     {
        //       name: self.data.seriesData.name,
        //       yAxis: 0,
        //       color: "#47A694",
        //       borderWidth: 0,
        //       data: self.data.seriesData.data,
        //     },
        //   ];
    
          const yAxis = [
            {
              labels: {
                formatter: function () {
                  return self.abbreviateNumber(this.value);
                },
              },
              lineWidth: 0,
              crosshair: true,
              gridLineWidth: 1,
              title: ''
            },
          ];

          self.chartData = {
            chart: {
              marginTop: this.ChartMarginTop(),
              backgroundColor: "transparent",
              type:'column',
              height: this.chartHeight(),
            },
            title: {
              text: "",
            },
            subtitle: {
              text: "",
            },
            credits: {
              enabled: false,
            },
            legend: {
              itemStyle: {
                fontSize: self.legendFontSize(),
              },
              enabled: self.plotLegend(),
              alignColumns: true,
              align: self.legendPosition(),
              y: 0,
              x: 0,
              squareSymbol: true,
              verticalAlign: "top",
              itemDistance: 35,
              margin: 0,
              padding: 0,
              symbolHeight: this.symbolHeight(),
              symbolWidth: this.symbolHeight(),
              symbolRadius: this.symbolRadius(),
              itemStyle: {
                fontFamily: 'Poppins',
                fontWeight: 600,
                color: "#a1a1a1",
                fontSize: "14px",
                letterSpacing: '.5px',
                textTransform: "capitalize",
                },
            },
            xAxis: [
              {
                categories: self.data?.categories,
                crosshair: true,
                tickWidth: 1,
                tickmarkPlacement: "on",
                labels: {
                  rotation: false,
                  style: {
                    fontSize: self.labelFontSize(),
                  },
                },
              },
            ],
            yAxis: yAxis,
            tooltip: {
              shared: true,
              formatter: function () {
                let mytooltip = "<b>" + this.points[0].key + "</b>";
                let rs = " ";
    
                for (let i = 0; i < this.points.length; i++) {
                  mytooltip +=
                    "<br/>" +
                    '<span style="color:' +
                    this.points[i].series.color +
                    '">●</span> ' +
                    this.points[i].series.name +
                    ": <b>" +
                    rs +
                    this.points[i].y.toLocaleString("en-US") +
                    "</b>";
    
                }
                return mytooltip;
              },
              borderWidth: 0,
              shadow: {
                color: "#d6d6d6",
                opacity: 0.1,
                width: 10,
              },
              borderRadius: 6,
              backgroundColor: "#ffffff",
            },
            plotOptions: {
                column:{
                    borderRadius: 5,
                },
            },
            series: this.data?.seriesData,
          };
        },
      },
    };
    </script>
    
    <style scoped>
    @media (max-width: 1400px) and (min-width: 1280px) {
      .adjustHeight {
        height: 350px !important;
      }
    }
    </style>
    